import React from "react";
import DoveMedLogo from "../../assets/images/logo.svg";

const Footer = (props) => {
  let d = new Date();
  const year = d.getFullYear();
  return (
    <footer className="flex pb-6 pl-6 pr-4">
      <div className="container-fluid max-w-screen-xl m-auto pb-6">
        <nav className="flex items-center justify-between flex-wrap py-6 pb-6">
          <a href="/" className="block mt-4 lg:inline-block lg:mt-0 mx-4">
            <img src={DoveMedLogo} height="37px" alt="DoveMed" />
          </a>
          <div className="w-full block lg:flex lg:items-center lg:w-auto">
            <div className="text-sm lg:flex-grow mr-5 font-bold">
              <a
                href="/"
                className="block mt-4 lg:inline-block lg:mt-0 uppercase  mx-4"
              >
                Home
              </a>
              <a
                href="/search/1/posts"
                className="block mt-4 lg:inline-block lg:mt-0 uppercase mx-4"
              >
                Search
              </a>
              <a
                href="/faq"
                className="block mt-4 lg:inline-block lg:mt-0 uppercase mx-4"
              >
                FAQ
              </a>
              <a
                href="/privacy-policy"
                className="block mt-4 lg:inline-block lg:mt-0 uppercase mx-4"
              >
                Privacy Policy
              </a>
              <a
                href="/about-us/terms-conditions"
                className="block mt-4 lg:inline-block lg:mt-0 uppercase mx-4"
              >
                Terms of Use
              </a>
            </div>
          </div>
        </nav>
        <p> DoveMed {year}. </p>
        <p>
          It is not the intention of DoveMed to provide specific medical advice.
          DoveMed urges its users to consult a qualified healthcare professional
          for diagnosis and answers to their personal medical Terms of Use
        </p>
      </div>
    </footer>
  );
};

export default Footer;
